import { ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { INTERCEPTOR_CONFIG_TOKEN, NetworkInterceptorService } from './network-interceptor.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';

@NgModule({ exports: [CommonModule], imports: [CommonModule], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: NetworkInterceptorService,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class NetworkInterceptorModule {
	constructor(@Optional() @SkipSelf() parentModule?: NetworkInterceptorModule) {
		if (parentModule) {
		  throw new Error(
			'NetworkInterceptorModule  is already loaded. Import it in the AppModule only');
		}
	  }
    static forRoot(configs?: any): ModuleWithProviders<NetworkInterceptorModule> {
		return {
			ngModule: NetworkInterceptorModule,
			providers: [
				{
					provide: INTERCEPTOR_CONFIG_TOKEN,
					useFactory: () => configs && configs['interceptor'] || {},
					multi: true
				},
			]
		};
	}
	static forChild(configs?: any): ModuleWithProviders<NetworkInterceptorModule> {
		return {
			ngModule: NetworkInterceptorModule,
			providers: [
				{
					provide: INTERCEPTOR_CONFIG_TOKEN,
					useValue: configs && configs['interceptor'] || {},
					multi: true
				},
			]
		};
	}
}
